import React, { useState, useEffect } from "react";
import "../Style/HeaderCaraousel.css";
import { useAuth } from "./UserContext.js";
const EventCaraousel = () => {
    const { options, covertDriveLinkToImage, convertGoogleDriveLinkToIframe } =
    useAuth();
  const [currentItemIndex, setCurrentItemIndex] = useState(1);
  const [isTransitioning, setIsTransitioning] = useState(false);
  const [showText, setShowText] = useState(false);
  const isMobile = window.innerWidth <= 768;
  const slides = [];
  slides.push(
    ...(options?.event?.map((event) => ({
      src: convertGoogleDriveLinkToIframe(event.video)
    })) || [])
  );
  const carouselItems = slides.length > 0
  ? [slides[slides.length - 1], ...slides, slides[0]]
  : [];
  useEffect(() => {
    const interval = setInterval(() => {
      if (!isTransitioning) {
        setShowText(false); // Hide text before the next image transition
        setCurrentItemIndex((prevIndex) => prevIndex - 1);
        setIsTransitioning(true);
      }
    }, 10000);

    return () => clearInterval(interval);
  }, [isTransitioning]);

  const handleTransitionEnd = () => {
    setIsTransitioning(false);
    setTimeout(() => setShowText(true), 2000); // Immediately show text with animation
    if (currentItemIndex === 0) {
      setCurrentItemIndex(carouselItems.length - 2);
    } else if (currentItemIndex === carouselItems.length - 1) {
      setCurrentItemIndex(1);
    }
  };

  return (
    <div className="carousel-container">
      {/* <h1
        className="content-h1"
        style={{ textAlign: "center", margin: "20px 0px" }}
      >
        Insight Video
      </h1> */}
      <div
        className="carouselInner"
        style={{
          transform: `translateX(-${currentItemIndex * 100}%)`,
          transition: isTransitioning ? "transform 1s ease-in-out" : "none",
        }}
        onTransitionEnd={handleTransitionEnd}
      >
        {carouselItems?.length>0?carouselItems.map((item, index) => (
          <div key={index} className="carouselSlide">
            <iframe
              src={item.src}
              width="100%"
              height={isMobile ? "200px" : "400px"}
              allow="autoplay"
              allowFullScreen
              frameBorder="0"
              className="carouselVideo"
            />
          </div>
        )):<p>No Event Available.</p>}
      </div>
    </div>
  );
};

export default EventCaraousel;
